import WhatsappMessagesEdit from './WhatsappMessagesEdit';
import WhatsappMessagesList from './WhatsappMessagesList';

export default {
  name: 'business_whatsapp_message',
  list: WhatsappMessagesList,
  edit: WhatsappMessagesEdit,
};
